module.exports = __webpack_public_path__ + "static/media/folder_font.7d1940dd.ico";